import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment.local';

@Component({
    selector: 'loading-creating-site',
    templateUrl: './loading-creating-site.component.html',
    styleUrls: ['./loading-creating-site.component.scss'],
})
export class LoadingCreatingSiteComponent {
    steps: string[];
    currentStep = 0;
    progress = 0;
    assetsUrl: string = environment.assets_url;
    mfsPath: string = environment.mfs_path;
    finished = false;

    constructor(private translate: TranslateService) {
        this.steps = [
            this.translate.instant('app.wizard.stepper_ia.loader.best-design'),
            this.translate.instant('app.wizard.stepper_ia.loader.creating-pages'),
            this.translate.instant('app.wizard.stepper_ia.loader.applying-colors'),
            this.translate.instant('app.wizard.stepper_ia.loader.rendering'),
            this.translate.instant('app.wizard.stepper_ia.loader.ordering'),
        ];
    }

    ngOnInit(): void {
        this.animateSteps();
    }

    animateSteps(): void {
        const stepDuration = 1500;
        const totalSteps = this.steps.length;

        for (let i = 0; i < totalSteps; i++) {
            setTimeout(() => {
                this.currentStep = i + 1;
                this.progress = ((i + 1) / totalSteps) * 80;
            }, stepDuration * i);
        }

        setTimeout(() => {
            this.progress = 80;
        }, stepDuration * totalSteps);
    }
}
